import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthClient from "../api/AuthClient";
import NoPartyBanner from "../components/NoPartyBanner";
import OfferDetail from "../components/OfferDetail";

const OfferDetailPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { promoter, city, offer } = location.state;

  const authClient: AuthClient = new AuthClient();
  const isLoggedIn = authClient.isLoggedIn();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/login");
    }
  }, [isLoggedIn, navigate]);

  if (offer && city) {
    return <OfferDetail promoter={promoter} offer={offer} partyCity={city} />;
  } else {
    return <NoPartyBanner />;
  }
};

export default OfferDetailPage;
